import { reportWebVitals } from 'src/helpers/reportWebVitals';
import { reportGoogleTranslate } from 'src/utils/reportGoogleTranslate/reportGoogleTranslate';
import { renderReactWithStyledComponents } from '../helpers/renderComponent';
import GiftApp from '../routes/GiftCertificate';

import '../styles/pages/gift_page.scss';

export default renderReactWithStyledComponents('GiftApp', GiftApp);

reportWebVitals();

reportGoogleTranslate();
